exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app-components-ExampleApp-exampleApp {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0; }\n", ""]);

// exports
exports.locals = {
	"exampleApp": "app-components-ExampleApp-exampleApp"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path][name]-[local]!./~/postcss-loader!./~/sass-loader!./app/components/ExampleApp.scss
// module id = 376
// module chunks = 0